var _defs, _path, _path2, _path3, _circle;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAuroraMark(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 72 72",
    fill: "none",
    role: "img",
    "aria-label": "Aurora Wealth Reserves",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "awrArc",
    x1: 8,
    y1: 64,
    x2: 64,
    y2: 8,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0D9488"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.55,
    stopColor: "#14B8A6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C9A227"
  })))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M36 62 C18 40 14 24 28 10 C36 2 48 6 50 20",
    stroke: "url(#awrArc)",
    strokeWidth: 7,
    strokeLinecap: "round",
    fill: "none"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M40 62 C28 44 28 28 38 16 C46 8 56 12 56 24",
    stroke: "url(#awrArc)",
    strokeWidth: 6,
    strokeLinecap: "round",
    fill: "none",
    opacity: 0.9
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M44 62 C36 46 36 32 44 22 C50 14 58 18 58 28",
    stroke: "url(#awrArc)",
    strokeWidth: 5,
    strokeLinecap: "round",
    fill: "none",
    opacity: 0.75
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 36,
    cy: 64,
    r: 3.5,
    fill: "#C9A227"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAuroraMark);
export default __webpack_public_path__ + "static/media/aurora-mark.c59ff5b03226cf6ef5ac83d3f6c3e828.svg";
export { ForwardRef as ReactComponent };